import { createSimplePageStrategy } from './simple-page.strategy-helper';

export const PrivacyPolicySeoStrategy = createSimplePageStrategy(
  'privacyPolicy',
  'privacy-policy',
  '/privacy-policy'
);
